import { MooringCategoryType } from './MooringArticleCategoryType';
import { ArticleTypeVariant } from './MooringArticleType';

export class MooringArticleProduct {
  static ApiUrl = 'api/mooring-article-products';

  Id!: number;
  MooringArticleId!: number;
  ProductId!: number;

  ProductName!: string;
  ProductSource!: number;
  ArticleNumber!: string;

  SupplierId!: number;
  SupplierName!: string;

  PrimaryDimension!: number;
  SecondaryDimension?: number;

  Category!: string;
  Type!: string;
  ProductType?: string;

  MBL?: number;

  CategoryType!: MooringCategoryType;
  TypeVariant!: ArticleTypeVariant;

  Created?: Date;
  Updated?: Date;
  IsDeleted?: boolean;
}
